import { FormControl, FormLabel, Input, InputProps } from '@chakra-ui/react'
import ErrorHelper from '../../../components/ErrorHelper'
import { formAccount } from '../storage'

export default function FormAccount() {
    return (
        <>
            <Name />
        </>
    )
}

function Name() {
    const { props, helper, error } = formAccount.useField<InputProps>('name')
    return (
        <FormControl mb={4}>
            <FormLabel>Nombre</FormLabel>
            <Input
                {...props}
                placeholder="Ingresar el nombre de la subcuenta"
                autoFocus
            />
            <ErrorHelper helper={helper || error} />
        </FormControl>
    )
}
